"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: testapi/check-deposit-testapi-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftestapi%2Fcheck-deposit-testapi-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckDepositTestApiServiceClient = exports.ReturnCheckDepositResponse = exports.ReturnCheckDepositRequest = exports.AcceptCheckDepositResponse = exports.AcceptCheckDepositRequest = exports.RejectCheckDepositResponse = exports.RejectCheckDepositRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const amount_1 = require("../common/amount");
const check_return_context_1 = require("../ledger/check-return-context");
const protobufPackage = 'com.step.testapi.proto';
function createBaseRejectCheckDepositRequest() {
    return { paymentId: '' };
}
exports.RejectCheckDepositRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        return obj;
    },
    create(base) {
        return exports.RejectCheckDepositRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRejectCheckDepositRequest();
        message.paymentId = object.paymentId ?? '';
        return message;
    },
};
function createBaseRejectCheckDepositResponse() {
    return {};
}
exports.RejectCheckDepositResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RejectCheckDepositResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRejectCheckDepositResponse();
        return message;
    },
};
function createBaseAcceptCheckDepositRequest() {
    return { paymentId: '', approvedAmount: amount_1.Amount.fromPartial({}), clearNow: false };
}
exports.AcceptCheckDepositRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            approvedAmount: isSet(object.approvedAmount)
                ? amount_1.Amount.fromJSON(object.approvedAmount)
                : amount_1.Amount.fromPartial({}),
            clearNow: isSet(object.clearNow) ? globalThis.Boolean(object.clearNow) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.approvedAmount !== undefined) {
            obj.approvedAmount = amount_1.Amount.toJSON(message.approvedAmount);
        }
        if (message.clearNow !== false) {
            obj.clearNow = message.clearNow;
        }
        return obj;
    },
    create(base) {
        return exports.AcceptCheckDepositRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAcceptCheckDepositRequest();
        message.paymentId = object.paymentId ?? '';
        message.approvedAmount = (object.approvedAmount !== undefined && object.approvedAmount !== null)
            ? amount_1.Amount.fromPartial(object.approvedAmount)
            : amount_1.Amount.fromPartial({});
        message.clearNow = object.clearNow ?? false;
        return message;
    },
};
function createBaseAcceptCheckDepositResponse() {
    return {};
}
exports.AcceptCheckDepositResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AcceptCheckDepositResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAcceptCheckDepositResponse();
        return message;
    },
};
function createBaseReturnCheckDepositRequest() {
    return { paymentId: '', returnContext: check_return_context_1.CheckReturnContext.fromPartial({}) };
}
exports.ReturnCheckDepositRequest = {
    fromJSON(object) {
        const message = {
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            returnContext: isSet(object.returnContext)
                ? check_return_context_1.CheckReturnContext.fromJSON(object.returnContext)
                : check_return_context_1.CheckReturnContext.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.returnContext !== undefined) {
            obj.returnContext = check_return_context_1.CheckReturnContext.toJSON(message.returnContext);
        }
        return obj;
    },
    create(base) {
        return exports.ReturnCheckDepositRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReturnCheckDepositRequest();
        message.paymentId = object.paymentId ?? '';
        message.returnContext = (object.returnContext !== undefined && object.returnContext !== null)
            ? check_return_context_1.CheckReturnContext.fromPartial(object.returnContext)
            : check_return_context_1.CheckReturnContext.fromPartial({});
        return message;
    },
};
function createBaseReturnCheckDepositResponse() {
    return {};
}
exports.ReturnCheckDepositResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ReturnCheckDepositResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseReturnCheckDepositResponse();
        return message;
    },
};
/**
 * Check Deposit testing API
 */
class CheckDepositTestApiServiceClient {
    rpc;
    name = 'com.step.testapi.proto.CheckDepositTestApiService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/test';
    methods = [{
            name: 'RejectCheckDeposit',
            requestType: exports.RejectCheckDepositRequest,
            responseType: exports.RejectCheckDepositResponse,
            authenticationOptions: undefined,
        }, {
            name: 'AcceptCheckDeposit',
            requestType: exports.AcceptCheckDepositRequest,
            responseType: exports.AcceptCheckDepositResponse,
            authenticationOptions: undefined,
        }, {
            name: 'ReturnCheckDeposit',
            requestType: exports.ReturnCheckDepositRequest,
            responseType: exports.ReturnCheckDepositResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Reject a check deposit.
     */
    rejectCheckDeposit(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Accept a check deposit.
     */
    acceptCheckDeposit(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Return a check deposit.
     */
    returnCheckDeposit(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CheckDepositTestApiServiceClient = CheckDepositTestApiServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=check-deposit-testapi-service.js.map